module.exports = __webpack_public_path__ + "img/Greuther-furth.d7eb4032.png";